import { api } from "../Configurations/axios";
import { CompanyCharacteristicsFinepModel } from "../Models/CompanyCharacteristicsFinepModel";
import { SectoralAspectsFinepModel } from "../Models/SectoralAspectsFinepModel";

const GetCompanyCharacteristicsByRegistrationIdAPI = async (id: string) => {
    try {
        var result = await api.get(`/CompanyCharacteristicsFinep/GetByRegistrationDocumentsId/${id}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetSectoralAspectsByRegistrationIdAPI = async (id: string) => {
    try {
        var result = await api.get(`/SectoralAspectsFinep/GetByRegistrationDocumentsId/${id}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PostCompanyCharacteristicsFinepAPI = async (data: CompanyCharacteristicsFinepModel) => {
    try {
        var result = await api.post('/CompanyCharacteristicsFinep/Post', data);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PostSectoralAspectsFinepAPI = async (data: SectoralAspectsFinepModel) => {
    try {
        var result = await api.post('/SectoralAspectsFinep/Post', data);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PutCompanyCharacteristicsFinepAPI = async (data: CompanyCharacteristicsFinepModel) => {
    try {
        var result = await api.put('/CompanyCharacteristicsFinep/Put', data);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PutSectoralAspectsFinepAPI = async (data: SectoralAspectsFinepModel) => {
    try {
        var result = await api.put('/SectoralAspectsFinep/Put', data);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetCompanyCharacteristicsByRegistrationIdAPI,
    GetSectoralAspectsByRegistrationIdAPI,
    PostCompanyCharacteristicsFinepAPI,
    PostSectoralAspectsFinepAPI,
    PutCompanyCharacteristicsFinepAPI,
    PutSectoralAspectsFinepAPI
}